import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";
import { isPullActiveCoach } from "../../../../utils/user-helpers";

const TeamPublished = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  const { pushAccountInfo, pressAccountInfo, referAsClients } =
    locals?.activeUserToRequest || {};
  const isCommunityChatEnabled =
    pushAccountInfo?.inAppCommunityEnabled ||
    pressAccountInfo?.inAppCommunityEnabled;

  const coachIsPullForRealsies = isPullActiveCoach(locals?.activeUserToRequest);
  const hideFromPush = locals?.editCycle?.hideFromPush;
  const isPullOnly =
    (coachIsPullForRealsies && !pushAccountInfo) ||
    (coachIsPullForRealsies && pushAccountInfo && hideFromPush);
  const isPullAndPush =
    coachIsPullForRealsies && pushAccountInfo && !hideFromPush;
  const memberLabel = referAsClients ? t("teams.teamPublished.clients") : t("teams.teamPublished.athletes");
  const showChatUi = !isPullOnly;

  const mainParagraph = isPullOnly ? (
    <p>{t("teams.teamPublished.publishedPullOnly", { memberLabel })}</p>
  ) : isPullAndPush ? (
    <p>{t("teams.teamPublished.publishedPullAndPush", { memberLabel })}</p>
  ) : (
    <p>{t("teams.teamPublished.publishedDefault")}</p>
  );

  return (
    <Modal
      className={"publish-team-modal"}
      header={false}
      toClear={["cycleId", "cycleName"]}
    >
      <div className={"body"}>
        <h3 className="text-center">{t("teams.teamPublished.title")}</h3>
        {mainParagraph}
        {pushAccountInfo && hideFromPush && (
          <p className="enable-chat">
            {t("teams.teamPublished.hiddenFromPushNote")}
          </p>
        )}
        <div className="divisor"></div>
        <p className="s1 mt-3 mb-3 text-center">
          <strong>{t("teams.teamPublished.whatHappensNext")}</strong>
        </p>
        <ul>
          <li>
            <p>
              {t("teams.teamPublished.newWorkoutsRelease", {
                members: isPullOnly
                  ? memberLabel
                  : isPullAndPush
                    ? t("teams.teamPublished.subscribersAndMembers", { memberLabel })
                    : t("teams.teamPublished.subscribers"),
              })}
            </p>
          </li>
          <li>
            <p>{t("teams.teamPublished.keepBuilding")}</p>
          </li>
          {showChatUi && (
            <li>
              <p>
                {t("teams.teamPublished.chatStatus", {
                  status: isCommunityChatEnabled
                    ? t("teams.teamPublished.chatEnabled")
                    : t("teams.teamPublished.chatDisabled"),
                })}
                {isPullAndPush && (
                  <> {t("teams.teamPublished.chatPushOnly")}</>
                )}
              </p>
            </li>
          )}
        </ul>

        <p>{t("teams.teamPublished.launchMessage")}</p>
      </div>

      <footer id="confirmation-modal-footer">
        <button
          type="button"
          data-button-type={"primary"}
          onClick={() => {
            submit(`/actions/refresh?`, {
              method: "GET",
              body: {
                "modal[type]": "",
                cycleId: "",
                cycleName: "",
              },
            });
          }}
        >
          <span>{t("teams.teamPublished.okay")}</span>
        </button>
      </footer>
    </Modal>
  );
};

export default TeamPublished;
